import Vue from "vue";
import Vuex from "vuex";
import messages from "dea-notify-client/src/modules/messages";
import orders from "./modules/orders";
import user from "./modules/user";
import myhome from "./modules/myhome";
import registrations from "./modules/registrations";
import bookmarks from "./modules/bookmarks";
import appConf from "../appConf"; // eslint-disable-line import/no-extraneous-dependencies
import gtmPlugin from "./plugins/gtmPlugin";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    config: appConf,
  },
  getters: {
    config: state => {
      return state.config;
    },
  },
  mutations: {},
  actions: {},
  modules: {
    orders,
    user,
    myhome,
    registrations,
    bookmarks,
    messages,
  },
  plugins: [gtmPlugin],
});
